/**
 * Represents the types of different dispatched action types.
 */
export enum DispatchedActionType {
	/**
	 * Indicates that dispatch action is a cancellation type.
	 */
	Cancellation = 0,

	/**
	 * Indicates that dispatch action is a dispatched service type.
	 */
	Service = 1
}